import {
  ApiAuthPayload,
  ApiService,
  ApiSyncType,
  SyncServiceAuthServiceEnum,
} from "@incendium/api";
import { syncService } from "Apis";

type AuthenticateSyncClientArgs = {
  service: ApiService;
  code: string;
  redirectUrl: string;
  shop?: string | null;
  oauthClientId?: number | null;
  linkAccountProjectId?: number | null;
};

export const authenticateSyncClient = async ({
  service,
  code,
  redirectUrl,
  shop,
  oauthClientId,
  linkAccountProjectId,
}: AuthenticateSyncClientArgs) => {
  const payload: ApiAuthPayload = {
    code,
    redirectUrl,
  };

  if (shop) {
    payload.shop = shop;
  }

  if (oauthClientId) {
    payload.oauthClientId = oauthClientId;
  }

  if (linkAccountProjectId) {
    payload.linkAccountProjectId = linkAccountProjectId;
  }

  return syncService.syncServiceAuth({
    service: service as unknown as SyncServiceAuthServiceEnum,
    payload,
  });
};

type LinkSyncClientArgs = {
  projectId: number;
  oauthClientId: number;
  type: ApiSyncType;
};

export const linkSyncClientToProject = async ({
  projectId,
  oauthClientId,
  type,
}: LinkSyncClientArgs) => {
  return syncService.syncServiceLinkAccount({
    projectId,
    oauthClientId,
    payload: {
      type,
    },
  });
};

